import { ListItem, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  borderBottom: '1px solid #ddd',
  borderRadius: 5,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '&:hover': {
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    '& .MuiListItemText-secondary': {
      color: 'white',
    },
  },
}));

export const StyledMessageCorrespondentText = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
});
